"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Theme
const StyledCoaster = _styledComponents.default.div.withConfig({
  displayName: "Coaster__StyledCoaster",
  componentId: "design-system__sc-1phbx13-0"
})(["box-sizing:border-box;border:1px solid ", ";width:96px;height:96px;text-align:center;border-radius:5px;display:grid;grid-template-rows:40px auto;grid-row-gap:0.5rem;padding:1rem 0;transition-duration:0.5s;color:", ";text-decoration:none;a + & > span{text-decoration:none;}a:hover + & > span{text-decoration:none;}&:hover{cursor:pointer;color:", ";border-color:", ";}& > div{margin:0 auto;}& > span{font-family:", ";font-size:", ";text-decoration:none;}&.selected{border-color:", ";color:", ";}"], _BaseTheme.default.colors.bluegray, _BaseTheme.default.colors.gray, _BaseTheme.default.colors.black, _BaseTheme.default.colors.gray, _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.regular, _BaseTheme.default.colors.blue, _BaseTheme.default.colors.blue);

const Coaster = _ref => {
  let {
    label,
    selected,
    iconType
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledCoaster, {
    className: selected && 'selected'
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: iconType,
    size: "40",
    profile: selected ? 'selected' : 'standard'
  }), /*#__PURE__*/_react.default.createElement("span", null, label));
};

Coaster.propTypes = {
  label: _propTypes.default.string.isRequired,
  iconType: _propTypes.default.string.isRequired,
  selected: _propTypes.default.bool
};
Coaster.defaultProps = {
  selected: false
};
var _default = Coaster;
exports.default = _default;